import React from 'react';
import './NavPages.css';
import leftArrow from './leftArrow.ico';
import rightArrow from './rightArrow.ico';

export const NavPages = () => {
	return(
		<nav className='navPages'>
			<img src={leftArrow} alt='icon'/>
			<p>1/1</p>
			<img src={rightArrow} alt='icon'/>
		</nav>
		)
}